import { OptionSetNumber } from "../common/types";

export const typesByField = {
  resolutionduconseildadministration: 948300000,
  reglementsgeneraux: 948300001,
  procesverbauxdesagaetags: 948300002,
  lettrespatentesetcharte: 948300003,
  rapportdactivite: 948300004,
  etatsfinanciers: 948300005,
};

export type AdmissibilityFilePost = {
  incidentid: string;
  vdl_type: OptionSetNumber;
  file: File;
};

export type AdmissibilityFileRow = {
  vdl_fichierdadmissibiliteid: string;
  vdl_nom: string;
  vdl_type: OptionSetNumber;
  vdl_fichier_name: string;
  vdl_fichier: string;
};
